export default __webpack_public_path__ + "static/media/prime-offer-4-cases-img.4945a575.svg";